var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "inbox" },
    [
      _c("loading", { attrs: { loaded: _vm.isInitialLoaded } }, [
        _c("div", { key: "content", staticClass: "inbox-content" }, [
          _c("div", { staticClass: "h2 page-title" }, [
            _vm._v(_vm._s(_vm.$t("inboxPage.pageTitle"))),
          ]),
          _c("div", { staticClass: "inbox-layout" }, [
            _c("div", { staticClass: "sidebar" }, [
              _c(
                "div",
                {
                  staticClass: "sidebar-item",
                  class: { active: _vm.currentTab === "agent" },
                  on: {
                    click: function ($event) {
                      return _vm.onTabChange("agent")
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("inboxPage.tabs.nola")) + " ")]
              ),
              _c(
                "div",
                {
                  staticClass: "sidebar-item",
                  class: { active: _vm.currentTab === "nolaNovel" },
                  on: {
                    click: function ($event) {
                      return _vm.onTabChange("nolaNovel")
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("inboxPage.tabs.nolaNovel")) + " ")]
              ),
            ]),
            _c(
              "div",
              { staticClass: "main-content" },
              [
                _c("div", { staticClass: "sub-tabs" }, [
                  _c(
                    "div",
                    { staticClass: "tabs-container" },
                    _vm._l(_vm.currentSubTabs, function (subTab) {
                      return _c(
                        "div",
                        {
                          key: subTab.value,
                          staticClass: "tab-item",
                          class: { active: _vm.currentSubTab === subTab.value },
                          on: {
                            click: function ($event) {
                              return _vm.onSubTabChange(subTab.value)
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(subTab.label) + " ")]
                      )
                    }),
                    0
                  ),
                ]),
                _c("notification-list", {
                  attrs: {
                    notifications: _vm.filteredNotifications,
                    "notification-type": _vm.currentTab,
                    "is-load-complete": _vm.isLoadComplete,
                  },
                }),
                _vm.showInfiniteLoading
                  ? _c(
                      "InfiniteLoading",
                      {
                        key: _vm.infiniteLoadingKey,
                        ref: "infiniteLoading",
                        on: { infinite: _vm.handleInfinite },
                      },
                      [
                        _c("span", {
                          attrs: { slot: "no-more" },
                          slot: "no-more",
                        }),
                        _c("span", {
                          attrs: { slot: "no-results" },
                          slot: "no-results",
                        }),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "space" }),
      _c("site-footer", { staticClass: "footer" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }